import { ROUTES } from 'constants/routes';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { useMswManager } from 'lib/util/useMswManager';
import { useQuery } from 'react-query';
import { ErrorResponse } from 'types/network';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';
import { useSnackbar } from 'notistack';

export interface VoidReason {
  encounterHeaderVoidReasonID: number;
  encounterHeaderVoidReason: string;
}

// Mock data for development and testing
const mockVoidReasons: VoidReason[] = [
  {
    encounterHeaderVoidReasonID: 1,
    encounterHeaderVoidReason: 'Duplicate Entry'
  },
  {
    encounterHeaderVoidReasonID: 2,
    encounterHeaderVoidReason: 'Incorrect Patient Information'
  },
  {
    encounterHeaderVoidReasonID: 3,
    encounterHeaderVoidReason: 'Service Not Performed'
  },
  {
    encounterHeaderVoidReasonID: 4,
    encounterHeaderVoidReason: 'Other'
  }
];

export const usePartnerGetEncounterHeaderVoidReasonList = (type = '1') => {
  const Axios = useAuthenticatedAxios();
  const snackbar = useSnackbar();

  // Setup MSW mock
  useMswManager(
    HrznGatewayMswBuilder.create().get(
      ROUTES.PartnerGetEncounterHeaderVoidReasonList,
      {
        path: ':id',
        data: mockVoidReasons
      }
    )
  );

  return useQuery<VoidReason[], ErrorResponse>(
    [ROUTES.PartnerGetEncounterHeaderVoidReasonList, type],
    async () => {
      const { data } = await Axios({
        method: 'get',
        url: `${type}/?route=${ROUTES.PartnerGetEncounterHeaderVoidReasonList}`
      });
      return data;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError: error => {
        snackbar.enqueueSnackbar(
          error.message || 'Error fetching void reasons',
          { variant: 'error' }
        );
      }
    }
  );
};
